import { useParams } from 'react-router'

import { getUserProfile, updateUserProfile } from '../../api'
import { EmailDraftTableProvider } from '../Email'
import { UserProfile, UserProfileLoader } from '../User'

import {
  QA_NAME_USER_PROFILE_PAGE,
  USER_PROFILE_PAGE_EMAIL_DRAFT_PREFIX,
} from './UserProfilePage.constants'
import {
  getUserProfilePageBrowserTabTitleKey,
  getUserProfilePreparedData,
} from './UserProfilePage.utils'
import { UserProfilePageActionsWidget } from './UserProfilePageActionsWidget'
import { UserProfilePageHeader } from './UserProfilePageHeader'
import { UserProfilePageTabs } from './UserProfilePageTabs'
import { UserProfilePageWidgetList } from './UserProfilePageWidgetList'

function UserProfilePage({
  Header = UserProfilePageHeader,
  Tabs = UserProfilePageTabs,
  browserTabTitleKey = 'BrowserTab.UserProfileTabTitleKey',
  getActionList,
  getAddNewOptions,
  getBrowserTabTitleKey = getUserProfilePageBrowserTabTitleKey,
  getContactsApi,
  getProfile = getUserProfile,
  getWidgetListPermissions,
  prepareData = getUserProfilePreparedData,
  updateProfile = updateUserProfile,
}) {
  const { inhabitantId } = useParams()

  async function getProfileData() {
    return getProfile({ id: inhabitantId })
  }

  async function updateProfileData(data) {
    return updateProfile({ data, id: inhabitantId })
  }

  return (
    <EmailDraftTableProvider prefix={USER_PROFILE_PAGE_EMAIL_DRAFT_PREFIX}>
      <UserProfile
        Header={Header}
        Loader={UserProfileLoader}
        Tabs={Tabs}
        actionsWidget={
          <UserProfilePageActionsWidget
            getActionList={getActionList}
            getAddNewOptions={getAddNewOptions}
          />
        }
        browserTabTitleKey={browserTabTitleKey}
        getBrowserTabTitleKey={getBrowserTabTitleKey}
        getProfileData={getProfileData}
        prepareData={prepareData}
        qaName={QA_NAME_USER_PROFILE_PAGE}
        updateProfileData={updateProfileData}
        widgets={
          <UserProfilePageWidgetList
            getContactsApi={getContactsApi}
            getPermissions={getWidgetListPermissions}
          />
        }
      />
    </EmailDraftTableProvider>
  )
}

export default UserProfilePage
